module.exports = __webpack_public_path__ + "img/theme-setup.0b467519.svg";